<template>
  <div class="hidden grid-cols-3 gap-12 max-w-78% mx-auto mb-36 lg:grid">
    <ListItem :name="__('page_tree.overview')" :selected="true" />
    <ListItem
      :name="__('page_tree.checkout')"
      :selected="isCheckoutView || isSuccessInvoiceView"
    />
    <ListItem
      :name="__('page_tree.confirmation')"
      :selected="isSuccessInvoiceView"
    />
  </div>
</template>

<script>
import { isCheckoutView, isSuccessInvoiceView } from '@/stores/View';
import ListItem from '@/components/PageTree/ListItem';

export default {
  components: {
    ListItem
  },
  setup() {
    return {
      isCheckoutView,
      isSuccessInvoiceView
    };
  }
};
</script>
